module.exports = "/images/_/_/_/_/site/resources/js/src/assets/images/icons/xls.png";